import { useCallback } from "react";

export const usePrivacySettingsExperience = () => {
  const showPrivacySettingsExperience = useCallback(() => {
    if (typeof window === "undefined") {
      return;
    }
    // Ours Privacy CMP. The SDK is only present on web once cmp-init has
    // loaded, so callers stay a no-op on native and before init resolves.
    const consent = (window as any).ours_consent;
    if (typeof consent?.showPreferences === "function") {
      consent.showPreferences();
    }
  }, []);

  return { showPrivacySettingsExperience };
};
